import $ from 'jquery';


export default () => {

    if($(window).width() < 1000) {
        $('.change-position-mobile').each(function(i, elem) {
            var target = $(elem).attr('data-target');
            $(elem).remove();
            var html = $(elem).html();
            $(target).append(html);
        });
    }
    
};



// WEBPACK FOOTER //
// ./scripts/libs/single-prodotto/mobile.js